import React, { FC } from 'react';
import { Layout, Spin } from 'antd';
import './App.css';
import {BrowserRouter as Router, Switch } from 'react-router-dom';
import { CustomHeader, CustomFooter, AuthRoute } from './components/common';
import { useDispatch } from 'react-redux';
import { login, logout } from './store/userSlice';　
import routes from './routes';
import axios from 'axios';

const { Suspense, useState ,useEffect } = React;
const { Header, Footer, Content } = Layout;

const fullScreenLoading = (
  <div className="full-screen">
    <Spin size="large" className="full-screen-loading"/>
  </div>
)

const App: FC = () => {
  // loading表示访问用户接口是否完成
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useDispatch();
  //访问用户是否登录接口
  useEffect(() => {
    axios.get('/isLogin').then(
      res => {
        // 如果是未登录状态，则会302到cas登录页，返回的是html
        if(res.headers['content-type'].includes('text/html')){
          // 未登录
          dispatch(logout());
          setLoading(false);
        } else {
          // 已登录
          dispatch(login());
          setLoading(false);
        }
      }, err => {
        dispatch(logout());
        setLoading(false);
      }
    );
  },[dispatch])

  return (
    <div>
      {
        loading ? (
          fullScreenLoading
        ) : (
          <Router>
          <Layout>
            <Header className='header'>
              <CustomHeader />
            </Header>
            <Content className="content">
              <Suspense fallback={fullScreenLoading}>
                <Switch>
                {
                  routes.map(({path, exact, component, auth}) => (
                    <AuthRoute path={path} exact={exact} component={component} auth={auth}/>//定义全局路由
                  ))
                }
                </Switch>
              </Suspense>
            </Content>
            <Footer className="footer">
              <CustomFooter />
            </Footer>
        </Layout>
      </Router>
        )
      }
    </div>
  )
}

export default App;
